<template>
  <div
    id="contas-contabeis-saldo-diferente-natureza"
    style="margin-top: 10px"
    class="w3-container">

    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando" class="w3-margin-bottom">
      <input
        class="w3-input w3-border w3-padding margin-bottom-filtro"
        type="text"
        placeholder="Pesquise por nome ou código da conta"
        v-model="filtro"
        v-on:keyup="filtrarContas()">
    </div>

    <div
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="(
        !processando &&
        ((!contas_filtradas) || (contas_filtradas.length == 0))
      )"
      v-cloak>
      <div class="w3-container w3-white">
        <p>Nenhum dado foi encontrado.</p>
      </div>
    </div>

    <div
      class="wrapper-componente"
      v-if="!processando && (contas_filtradas) && (contas_filtradas.length > 0)">

      <div
        class="card-informacoes w3-container"
        v-for="(conta, conta_index) in novasContasFiltradas"
        :key="conta_index">

        <div class="w3-col s12">
          <label>Conta: </label>
          <strong>{{conta.conta_mascara}}</strong>
        </div>

        <div class="w3-col s12">
          <label>Nome: </label>
          <strong>{{conta.nome_conta}}</strong>
        </div>

        <div class="w3-col s12">
          <label>Natureza: </label>
          <strong>{{naturezaConta(conta.natureza)}}</strong>
        </div>

        <div class="w3-col s12">
          <label>Saldo: </label>
          <strong :class="corSaldo(conta.saldo_atual)">
            R$ {{nomeNatureza(conta.saldo_atual)}}
          </strong>
        </div>
      </div>

      <paginacao
        @pagina="mudarPagina"
        :pagina-atual="pagina_atual"
        :itens-por-pagina="itens_por_pagina"
        :total-resultados="total_resultados"
        :total-de-paginas="total_de_paginas"/>
    </div>
  </div>
</template>

<script>
  import Paginacao from '@/components/Paginacao'
  import toastr from 'toastr'
  
  export default {
    name: 'ContasContabeisSaldoDiferenteNatureza',
    
    props: ['contas_contabeis','contas_saldo_dif_natureza_carregando'],
    
    components: {
      Paginacao
    },

    data() {
      return {
        filtro: '',
        processando: false,
        contas_filtradas: [],

        pagina_atual: 0,
        total_resultados: 0,
        total_de_paginas: 0,
        itens_por_pagina: 20
      }
    },
    
    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    methods: {
      mudarPagina(numero_da_pagina) {
        this.pagina_atual = numero_da_pagina;
      },

      filtrarContas() {
        this.contas_filtradas = [];
        this.mudarPagina(0);

        if(this.filtro == '') {
          this.contas_filtradas = this.contas_contabeis;
          return;
        }

        for (var i = 0; i < this.contas_contabeis.length; i++) {
          if (this.contas_contabeis[i].nome_conta.toUpperCase().indexOf(this.filtro.toUpperCase()) > -1) {
            this.contas_filtradas.push(this.contas_contabeis[i]);
          }

          if (this.contas_contabeis[i].conta_contabil_id.replace(".", "").indexOf(this.filtro) > -1) {
            this.contas_filtradas.push(this.contas_contabeis[i]);
          }
        }
      },

      naturezaConta(elem) {
        if (elem == "D") {
          return "Débito";
        }
        
        return "Crédito";
      },

      corSaldo(elem) {
        if(parseFloat(elem) > 0) {
          return "w3-text-green"
        }
        else if (parseFloat(elem) < 0) {
          return "w3-text-red"
        }

        return '';
      },

      nomeNatureza(elem) {
        if (parseFloat(elem) > 0) {
          return elem + " D";
        }
        else if (parseFloat(elem) < 0) {
          return (elem).substring(1) + " C";
        }
        else  {
          return elem;
        }
      },

      toogleCard(index, condicional) {
        this.$set(index, 'mostrar', condicional);
      }
    },

    created() {
      this.contas_filtradas = this.contas_contabeis;
    },

    computed: {
      novasContasFiltradas() {
        this.total_resultados = this.contas_filtradas.length
        this.total_de_paginas =  Math.ceil(this.total_resultados / this.itens_por_pagina)

        if (this.pagina_atual >= this.total_de_paginas) { 
          this.pagina_atual = this.total_de_paginas;
        }

        var index = this.pagina_atual * this.itens_por_pagina
        return this.contas_filtradas.slice(index, index + this.itens_por_pagina)
      }     
    }
  }
</script>

<style scoped>
  .card-informacoes {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  .tr-items:hover, .tr-items:hover td:last-child {
    background: #636363;
    color:#fff !important;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  
  th {
    white-space: nowrap;
  }
  
  .wrapper-componente {
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/ContasContabeisSaldoDiferenteNatureza.vue